import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState, useEffect } from 'preact/hooks';
import { useAuth } from '../../auth/useAuth';
import { clientCompanyApi } from '../../api/clientCompany';
import { UserManagement } from './users/UserManagement';
export function SettingsUsers({ clientCompanyId }) {
    const { userProfile, userCompanyRoleSets } = useAuth();
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const effectiveCompanyId = clientCompanyId || userProfile?.ClientCompanyId;
        if (!effectiveCompanyId) {
            setError('No company selected');
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        // Check if user has access to this company
        const roleSet = userCompanyRoleSets?.find(rs => rs.ClientCompanyId === effectiveCompanyId);
        if (!roleSet) {
            setError('You do not have access to this company');
            setSelectedCompany(null);
            setLoading(false);
            return;
        }
        // Fetch full company data (Settings pages need complete company info)
        clientCompanyApi.getById(effectiveCompanyId)
            .then(res => {
            if (res.error || !res.data) {
                setError(res.error || 'Failed to load company');
                setSelectedCompany(null);
            }
            else {
                setSelectedCompany(res.data);
            }
        })
            .catch(() => {
            setError('Failed to load company');
            setSelectedCompany(null);
        })
            .finally(() => {
            setLoading(false);
        });
    }, [clientCompanyId, userProfile?.ClientCompanyId, userCompanyRoleSets]);
    if (loading) {
        return (_jsx("div", { className: "p-6 max-w-4xl mx-auto", children: _jsx("div", { className: "flex items-center justify-center py-12", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-slate-400 mb-4", children: _jsx("svg", { className: "w-16 h-16 mx-auto", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" }) }) }), _jsx("h3", { className: "text-lg font-medium text-slate-900 dark:text-white mb-2", children: "Loading User Management" }), _jsx("p", { className: "text-slate-600 dark:text-slate-300", children: "Setting up user management interface..." })] }) }) }));
    }
    if (error) {
        return (_jsx("div", { className: "p-6 max-w-4xl mx-auto", children: _jsxs("div", { className: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4", children: [_jsx("div", { className: "text-red-700 dark:text-red-400 font-medium mb-1", children: "Error" }), _jsx("div", { className: "text-sm text-red-600 dark:text-red-300", children: error })] }) }));
    }
    if (!selectedCompany)
        return null;
    return (_jsxs("div", { className: "p-6 max-w-7xl mx-auto", children: [_jsxs("div", { className: "mb-8", children: [_jsx("h1", { className: "text-2xl font-bold text-slate-900 dark:text-white mb-2", children: "User Management" }), _jsx("p", { className: "text-slate-600 dark:text-slate-300", children: "Manage user roles and permissions for your organization" })] }), _jsx("div", { className: "bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-6", children: _jsx(UserManagement, { selectedCompany: selectedCompany }) })] }));
}
